import { useEffect, useState } from "react";

/**
 * 値が変更されてから `delay` ms 経過するまで値の反映を遅延させるシンプルなデバウンスフック。
 * 検索入力欄のリクエスト抑制など、入力イベントを遅延伝播させたい場面で利用する。
 *
 * @param value 即時に更新される元の値
 * @param delay 反映を遅らせる時間 (ms)。既定値 250ms。
 * @returns `delay` 経過後に更新される値
 */
export const useDebouncedValue = <T,>(value: T, delay = 250): T => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(id);
  }, [value, delay]);

  return debounced;
};

export default useDebouncedValue;
